// extracted by mini-css-extract-plugin
module.exports = {"calculator":"calculator_calculator__2cUz2"};